import { H1 } from '@berlitz/globals'
import { Grid } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'
import { StyledMenuTabItem } from '../../../components/MenuTab/style'
import { LinkProp, StyledGridProp } from './interface'

export const StyledGrid = styled(Grid)<StyledGridProp>`
  padding: 0;
  padding-right: ${({ theme, withSidebar }) => (withSidebar ? theme.space.lg : '0')};

  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding-right: 0;
  }

  ${StyledMenuTabItem} {
    min-width: 114px;
    border-right: 1px solid ${({ theme }) => theme.palette.gray50};
    padding: ${({ theme }) => theme.space.xs};

    &:last-of-type {
      border-right: 0
    }

    ${({ role }) =>
      role === 'full' &&
      css`
        min-width: 57px;
      `}
  }

  ${StyledMenuTabItem}:nth-child(${({ activeTab }) => activeTab}) {
    border-bottom: ${({ theme }) => `4px solid ${theme.palette.blue100}`};
    background-color: ${({ theme }) => theme.colors.ui07};
  }
`

export const StyledH1 = styled(H1)`
  margin-bottom: ${({ theme }) => theme.space.xs};
`

export const ContentBox = styled.div`
  margin-top: ${({ theme }) => theme.space.sm};
`

export const MenuTabBox = styled.div`
  width: 100%;
  min-width: max-content;
`

export const Link = styled.a<LinkProp>`
  span {
    justify-content: center;
    color: ${({ theme }) => theme.palette.blueGray60};

    ${({ theme, active }) =>
      active &&
      css`
        color: ${theme.colors.brandPrimary};
      `}
  }
`
